import { gql } from '__generated__';

export default gql(`
  query GetTicketList($event_id: ID!) {
    event(id: $event_id) {
      tickets {
        id
        title
        active
      }
    }
  }
`);
